import React, { useEffect, Suspense, lazy, useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import Cookies from 'js-cookie';
import PageLoading from '../components/common/spinners/PageLoading'
import EnquiryPage from '../components/common/page/EnquiryPage'
import NotFound from '../pages/not-found/NotFound '



const Home = lazy(() => import('../pages/enquiry/home/Home'))
const Prospects = lazy(() => import('../pages/enquiry/prospects/Prospects'))
const ProspectView = lazy(() => import('../pages/enquiry/view-prospect/ViewProspect'))
const CUProspect = lazy(() => import('../pages/lead/cu-prospect/CUProspect'))
const MyBucket = lazy(() => import('../pages/enquiry/my-bucket/MyBucket'))
const ViewEnquiry = lazy(() => import('../pages/enquiry/view-enquiry/ViewEnquiry'))
const ScheduleCall = lazy(() => import('../pages/enquiry/schedule-call/ScheduleCall'))
const AttendHome = lazy(() => import('../pages/enquiry/attend/AttendHome'))
const EnquiryForm = lazy(() => import('../pages/enquiry/enquiry-form/EnquiryForm'))
const ConfirmEnquiry = lazy(() => import('../pages/enquiry/confirm-enquiry/ConfirmEnquiry'))
const ViewEnquiryForm = lazy(() => import('../pages/enquiry/view-enquiry-form/ViewEnquiryForm'))
const EnquiryCalendar = lazy(() => import('../pages/enquiry/calendar/EnquiryCalendar'))
const SearchProspect = lazy(() => import('../pages/lead/search-prospect/SearchProspect'))
const Duplicate = lazy(() => import('../pages/lead/duplicate/Duplicate'))
const SingleProspectView = lazy(() => import('../pages/lead/search-prospect/ViewProspect'))
const Settings = lazy(() => import('../pages/enquiry/settings/Settings'))
const InstallationSlot = lazy(() => import('../pages/enquiry/installation-slot/InstallationSlot'))


const EnquiryRouter = () => {
    let isAuthenticated = false
    const [pageHead, setPageHead] = useState({ title: null, desc: null })
    const rfs_tkn = Cookies.get('_rfs_tkn');
    const DVC_ID = Cookies.get('DVC_ID');


    if (DVC_ID && rfs_tkn) {
        isAuthenticated = true
    }

    useEffect(() => {
        // Change Title
        document.title = `Enquiry | Sales App | Alliance`;

        // eslint-disable-next-line
    }, [])


    return (
        <EnquiryPage pageHead={pageHead}>

            <Suspense fallback={<PageLoading />}>

                <Routes>

                    {/* Home */}
                    <Route path='/' element={<PrivateRoute element={<Home setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Prospects */}
                    <Route path='/prospects-queue' element={<PrivateRoute element={<Prospects setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/prospects-queue/register' element={<PrivateRoute element={<CUProspect setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/prospects-queue/:prospect_id' element={<PrivateRoute element={<ProspectView setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Duplicate */}
                    <Route path='/bucket-list/duplicate/:primary_number' element={<PrivateRoute element={<Duplicate setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Bucket */}
                    <Route path='/bucket-list' element={<PrivateRoute element={<MyBucket setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/bucket-list/:prospect_id/reg-update' element={<PrivateRoute element={<CUProspect setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/bucket-list/:prospect_id/:enquiry_id' element={<PrivateRoute element={<ViewEnquiry setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/bucket-list/:prospect_id/:enquiry_id/initial-call' element={<PrivateRoute element={<ScheduleCall setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/confirm-enquiry' element={<PrivateRoute element={<ConfirmEnquiry setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Enquiry attend */}
                    <Route path='/bucket-list/:prospect_id/:enquiry_id/attend' element={<PrivateRoute element={<AttendHome setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/e-form/:e_form_srl_no' element={<PrivateRoute element={<ViewEnquiryForm setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/e-form' element={<PrivateRoute element={<EnquiryForm setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Calendar */}
                    <Route path='/calendar/:view/:theYear/:theMonth/:theDate' element={<PrivateRoute element={<EnquiryCalendar setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Home */}
                    <Route path='/prospect/search' element={<PrivateRoute element={<SearchProspect setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />
                    <Route path='/prospect/:prospect_id/view' element={<PrivateRoute element={<SingleProspectView setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Installation Slot */}
                    <Route path='/installation-slot' element={<PrivateRoute element={<InstallationSlot setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />

                    {/* Settings */}
                    <Route path='/settings' element={<PrivateRoute element={<Settings setPageHead={setPageHead} />} isAuthenticated={isAuthenticated} />} />



                    {/* 404 Route */}
                    <Route path="/*" element={<NotFound setPageHead={setPageHead} />} />
                </Routes>
            </Suspense>
        </EnquiryPage>
    )
}

export default EnquiryRouter


function PrivateRoute({ element, isAuthenticated, }) {
    return isAuthenticated ? element : window.location.href = 'https://worker.alliancedev.in/?page=home';
}

